import { observer } from "mobx-react-lite"

import { Button } from "@/components/Button/Button.tsx"
import { Dialog } from "@/components/Dialog/Dialog.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"
import { ScriptEditDialogContent } from "@/routes/tasks/TaskViewScene/InitRuntimeConfig/ScriptEditDialogContent.tsx"
import { TaskSettingsJsonModel } from "@/routes/tasks/TaskViewScene/TaskSettingsJsonModel.ts"


export const TaskSettingsJsonDialog = observer((props: {
  taskId: string
}) => {
  return (
    <Dialog
      title="Task settings"
      trigger={(
        <Button kind="alternative">
          Update settings
        </Button>
      )}
      maxWidth="100%"
    >
      <TaskSettingsJsonDialogContent taskId={props.taskId} />
    </Dialog>
  )
})

const TaskSettingsJsonDialogContent = observer((props: {
  taskId: string
}) => {
  const context = useOrgContext()
  const model = useModel(() => {
    return new TaskSettingsJsonModel(props.taskId, context.queries)
  }, [props.taskId, context.queries])

  return (
    <ScriptEditDialogContent
      initialValue={model.currentJson.get()}
      onSave={(value) => model.save(value)}
      onSaveAndRun={(value) => model.save(value)}
      isReadonly={false}
      canRun={false}
    />
  )
})